(function($) {
    var element = document.getElementById("contact-map");

    if (!element || !window.google) return;

    function initialize() {
        var latLng = new google.maps.LatLng(63.82496, 20.26005);

        var mapOptions = {
          center: latLng,
          zoom: 14,
          scrollwheel: false,
          draggable: false
        };

        var map = new google.maps.Map(element,
            mapOptions);

        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            title:"U&me Hotel",
            icon: require('../../img/map-icon.png'),
        });

        var center;

        function calculateCenter() {
            center = map.getCenter();
        }

        google.maps.event.addDomListener(map, 'idle', function() {
            calculateCenter();
        });

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(center);
        });

      }
      google.maps.event.addDomListener(window, 'load', initialize);

})(jQuery);
